module.exports = __webpack_public_path__ + "media/step-01.f29f48d8.mp4";